<div class="row mb-3">
  <div class="col-6">
    <p-autoComplete [(ngModel)]="pessoaAtual" [forceSelection]="true" [autoHighlight]="true"
      [ngModelOptions]="{standalone: true}" [field]="pessoaAutoComplete.conversor"
      [suggestions]="pessoaAutoComplete.lista" (completeMethod)="pessoaAutoComplete.filtrar($event)"
      inputStyleClass="form-control form-control-sm" minLength="2" (onSelect)="adicionar()"
      [style]="{ width: 'calc(100% - 36px)', float: 'left' }">
      <ng-template let-pessoa pTemplate="item">
        {{pessoa.cpf_cnpj | CPF}} - {{pessoa.nome}}
      </ng-template>
    </p-autoComplete>
    <button class="btn btn-sm btn-outline-secondary float-right" type="button" data-toggle="modal"
      style="border-bottom-left-radius: 0px;  border-top-left-radius: 0px;" data-target="#dialogPessoa">
      <i class="fa fa-user-plus"></i>
    </button>
  </div>
</div>
<div class="row">
  <div class="col-auto" *ngFor="let item of entidade?.fiscais; let idx = index">
    <span class="badge rounded-pill bg-secondary text-white p-2">
      {{item.pessoa.nome}}
      <span (click)="remover(item, idx)" class="badge rounded-pill cursor-pointer bg-light text-secondary"
        style="cursor: pointer; padding-left: 0.5em; padding-right: 0.5em;">x</span>
    </span>
  </div>
</div>

<lib-pessoa-cadastro-dlg (callback)="adicionar($event)" [login]="login"></lib-pessoa-cadastro-dlg>